import React from 'react';
import Cookies from 'universal-cookie';

const AudiencesInput = ({
    input,
    setAudiencesModalOpen
}) => {
    const cookies = new Cookies();

    const handleChange = () => {
        const oneDayFromNow = new Date();
        oneDayFromNow.setDate(oneDayFromNow.getDate() + 1);
        cookies.set('AudienceSet', true, { 
            expires: oneDayFromNow
        });
        setAudiencesModalOpen(false);
    };

    return input.values.map(value => {
        return (
            <label key={`radio-${input.name}-${value.value}`} className="radioLabel">
                <input
                    id={`${input.name}-${value.value}`}
                    type="radio"
                    name={input.name}
                    value={value.value}
                    onBlur={input.onBlur}
                    onChange={e => {
                        handleChange(e);
                        if (input?.onChange && typeof input.onChange == 'function')
                            input.onChange(e);
                    }}
                    onClick={e => {
                        handleChange(e);
                        if (input?.onClick && typeof input.onClick == 'function')
                            input.onClick(e);
                    }} 
                />
                    {value.image && <value.image />}
                    {(value?.title || value?.tippyText) && <p className='tippy-text'>{value.title}</p>}
            </label>
        )
    })
}

export default AudiencesInput;